/* PawLi header — mobile hamburger -> accordion drawer. */
class PawliHeader extends HTMLElement {
  connectedCallback() {
    this.burger = this.querySelector('.pawli-header__burger');
    this.drawer = this.querySelector('.pawli-header__drawer');
    if (!this.burger || !this.drawer) return;
    this.burger.addEventListener('click', () => this.toggle());
    this.drawer.querySelectorAll('a').forEach((a) =>
      a.addEventListener('click', () => this.close())
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }
  toggle() {
    this.open ? this.close() : this.show();
  }
  show() {
    this.open = true;
    this.drawer.hidden = false;
    void this.drawer.offsetHeight;
    this.classList.add('is-open');
    this.burger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  close() {
    if (!this.open) return;
    this.open = false;
    this.classList.remove('is-open');
    this.burger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    const drawer = this.drawer;
    setTimeout(() => {
      if (!this.open) drawer.hidden = true;
    }, 260);
  }
}
if (!customElements.get('pawli-header')) customElements.define('pawli-header', PawliHeader);
